export const loginAuthBodyDefault = {};

export const qsConfig = {
  addQueryPrefix: true,
};

export const headerLogin = {
  "Content-Type": "application/x-www-form-urlencoded",
};
